module.exports = __webpack_public_path__ + "dcc18554e63c81140e3f36a7a3bf94b2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/bun-s.png
// module id = 2162
// module chunks = 0